import React from 'react'
import { render } from 'react-dom'
import App from '~/App/App'

import './bootstrap';

render((<App />), document.getElementById('content'));
